import * as apiRoutes from '../../apiRoutes';
import { actionTypes } from "../../actionTypes";
import { AuthUrl, ErrorData } from "../../constants";
import * as api from '../../tools/apiMiddleware';

const initialState = {
    data: { step: VerificationSteps },
    isLoading: false,
    hasErrorOccured: false,
    errorData: ErrorData,
    systemMessage: ''
};

export const VerificationSteps = {
    Skip: 0,
    EmailVerification: 1,
    Verify2FA: 2,
    Disabled: 3
};

export const actionCreators = {
    login: (username, password) => async (dispatch) => {

        let url = AuthUrl + apiRoutes.Login;
        await api.postRequest(dispatch, url, { username, password }, actionTypes.LOGIN, actionTypes.LOGIN_SUCCESS, actionTypes.LOGIN_FAIL, true);

    },
    purge: () => async (dispatch) => {

        let url = AuthUrl + apiRoutes.PurgeCookies;
        await api.getRequest(dispatch, url, actionTypes.PURGE, actionTypes.PURGE, actionTypes.PURGE);
    },
    notification: () => async (dispatch) => {
        const url = AuthUrl + 'Notification';

        await api.getRequest(dispatch, url, '', 'SYSTEM_NOTIFCATION', 'SYSTEM_NOTIFCATION');
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'SYSTEM_NOTIFCATION':
            return {
                ...state,
                systemMessage: action.data.htmlMessage
            }
        case actionTypes.LOGIN:
            return {
                ...state,
                data: state.data,
                isLoading: true,
                hasErrorOccured: false
            };
        case actionTypes.LOGIN_SUCCESS:
            return {
                ...state,
                data: action.data,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.LOGIN_FAIL:
            return {
                ...state,
                isLoading: false,
                data: state.data,
                hasErrorOccured: true,
                errorData: action.data
            };
        case actionTypes.PURGE:
            return {
                ...state,
                data: state.data,
                isLoading: false,
                hasErrorOccured: false
            };
    }
    return state;
};


// WEBPACK FOOTER //
// ./src/store/Auth/LoginStore.js